module.exports = __webpack_public_path__ + "static/media/halo-auto-mobile.4d8eed63.svg";